/**
 * Dialog components: `MuiDialog`, `MuiDialogActions`, `MuiDialogContent`, `MuiDialogTitle` — borders, padding, radius.
 * Discoverability: `MuiDialog`, `DialogTitle`, `DialogActions`, `DialogContent`.
 *
 * @see https://mui.com/material-ui/api/dialog/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

export function muiDialog(
  theme: Theme,
): Pick<Components<Theme>, 'MuiDialog' | 'MuiDialogActions' | 'MuiDialogContent' | 'MuiDialogTitle'> {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundImage: 'none',
          borderRadius: 12,
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          borderTop: `1px solid ${theme.palette.border.light}`,
        },
        spacing: {
          padding: theme.spacing(3),
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {},
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
          borderBottom: `1px solid ${theme.palette.border.light}`,
        },
      },
    },
  };
}
